import type { Layer } from "../../design";

// Each org page's views, kept apart from the lazy-loaded pages so the
// sidebar's hover panel can list them without pulling the pages in.

export const ACTIVITY_LAYERS: Layer<string>[] = [
  { value: "sessions", label: "Sessions", icon: "clock" },
  { value: "logs", label: "Request logs", icon: "menu" },
  { value: "usecases", label: "Use cases", icon: "target" },
];

export type GovernanceTab = "budgeting" | "alerts" | "chargeback" | "audit";
export const GOVERNANCE_LAYERS: Layer<GovernanceTab>[] = [
  { value: "budgeting", label: "Budgets", icon: "spend", group: "Controls" },
  { value: "alerts", label: "Alerts", icon: "alert", group: "Controls" },
  {
    value: "chargeback",
    label: "Chargeback",
    icon: "credits",
    group: "Reports",
  },
  { value: "audit", label: "Audit log", icon: "eye", group: "Reports" },
];

export type PeoplePanel = "people" | "teams" | "devices";
export function peopleLayers(devices: boolean): Layer<PeoplePanel>[] {
  return [
    { value: "people", label: "Members", icon: "users" },
    { value: "teams", label: "Teams", icon: "seats" },
    ...(devices
      ? [
          {
            value: "devices" as const,
            label: "Devices",
            icon: "devices" as const,
          },
        ]
      : []),
  ];
}

const SETTINGS_TABS = [
  { key: "organization", label: "General", icon: "settings" },
  { key: "billing", label: "Billing", icon: "subscription" },
  { key: "api", label: "Org API keys", icon: "keys" },
  { key: "privacy", label: "Privacy", icon: "lock" },
  { key: "notifications", label: "Notifications", icon: "mail" },
] as const;
export type OrgSettingsTab = (typeof SETTINGS_TABS)[number]["key"];
export const ORG_SETTINGS_LAYERS: Layer<OrgSettingsTab>[] = SETTINGS_TABS.map(
  (t) => ({
    value: t.key,
    label: t.label,
    icon: t.icon,
    group: "Organization",
  }),
);
